<template>
  <div class="leftNav">
    <el-row class="menu_page">
      <el-col>
        <el-menu
          mode="vertical"
          :default-active="$route.path"
          active-text-color="#A30815"
          :unique-opened="true"
        >
          <template v-for="item in this.menu">
            <el-submenu
              v-if="item.children"
              :index="String(item.id)"
              :key="item.id"
            >
              <template slot="title">
                <span slot="title">{{ item.name }}</span>
              </template>
              <router-link
                v-for="(citem, cindex) in item.children"
                :to="citem.path"
                :key="cindex"
              >
                <el-menu-item :index="citem.path">
                  <span slot="title">{{ citem.name }}</span>
                </el-menu-item>
              </router-link>
            </el-submenu>
            <router-link :to="item.path" :key="item.path" v-else>
              <el-menu-item :index="item.path">
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </router-link>
          </template>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "OverSeaLeftNav",
  data() {
    return {
      menu: []
    }
  },
  methods: {
   
  },
  created(){
      let that = this;
      axios.get(this.COMMON.httpUrl + '/api/articleType/getOverSeaList', {
            }).then(function (response) {
              var data = response.data;
              console.log(data);
              if(data.code==200){
                that.menu = data.data;
              }
             
            }).catch(function (error) {
              console.log(error)
            });
        
  },
  mounted() {
    
  },
};
</script>

